export default function PreviewIcon() {
  return (
    <svg viewBox="0 0 24 24">
      <rect id="g" width="24" height="24" fill="none" />
      <path
        id="h"
        d="M12,19.64c-2.1,.04-4.17-.57-5.9-1.76-1.83-1.36-3.27-3.18-4.18-5.27-.18-.38-.18-.82,0-1.21,.91-2.09,2.36-3.91,4.19-5.28,1.73-1.19,3.8-1.8,5.9-1.76,2.1-.04,4.17,.57,5.9,1.76,1.83,1.36,3.27,3.18,4.18,5.27,.18,.38,.18,.82,0,1.21-.91,2.09-2.36,3.91-4.18,5.27-1.73,1.19-3.79,1.8-5.9,1.76Zm0-13.59c-1.76-.05-3.49,.47-4.94,1.46-1.56,1.16-2.79,2.71-3.57,4.49,.78,1.78,2.01,3.33,3.57,4.49,1.45,1,3.18,1.51,4.94,1.46,1.76,.05,3.49-.47,4.94-1.46,1.56-1.16,2.78-2.71,3.56-4.49-.78-1.78-2.01-3.33-3.57-4.49-1.45-1-3.18-1.51-4.93-1.46h0Zm-.1,10.08c-2.28,0-4.12-1.85-4.12-4.13,0-2.28,1.85-4.12,4.13-4.12s4.12,1.85,4.12,4.13c0,2.28-1.85,4.12-4.13,4.12h0Zm0-6.75c-1.45,0-2.62,1.18-2.62,2.62s1.18,2.62,2.62,2.62,2.62-1.18,2.62-2.62h0c0-1.45-1.18-2.62-2.62-2.62h0Z"
        fill="#333"
      />
    </svg>
  );
}
